import { User } from '@app/helpers';

import {
    ACTION_REMOVE_USER,
    ACTION_SET_SKIP_PRIMARY_YAT_FLOW,
    ACTION_SET_USER,
    ACTION_SET_USER_OPT_IN,
    ACTION_SET_USER_OPT_INS,
    type UserActionTypes,
    type UserState,
} from '../types/user';

const defaultState: UserState = {
    isRegisteredUser: false,
    isVerifiedUser: false,
    primaryYat: undefined, // todo check `eid_status === 'Confirmed'`
    userAccount: undefined,
    userClass: undefined,
    skipPrimaryYatFlow: false,
    optIns: [],
};
export function user(state: UserState = defaultState, action: UserActionTypes): UserState {
    switch (action.type) {
        case ACTION_SET_USER: {
            const userClass = new User(action.user);
            return {
                ...state,
                isRegisteredUser: Boolean(action.user.user?.email),
                isVerifiedUser: Boolean(action.user?.user?.email_verified_at),
                userAccount: { ...state?.userAccount, ...action.user },
                userClass,
                primaryYat: action.user.user.eid,
                skipPrimaryYatFlow: false,
            };
        }
        case ACTION_REMOVE_USER:
            localStorage.removeItem('ftue');
            return state;
        case 'ACTION_SET_USER_PRIMARY_YAT':
            return {
                ...state,
                primaryYat: action.primaryYat,
            };
        case ACTION_SET_SKIP_PRIMARY_YAT_FLOW:
            return {
                ...state,
                skipPrimaryYatFlow: action.skip,
            };
        case ACTION_SET_USER_OPT_INS:
            return {
                ...state,
                optIns: action.optIns,
            };
        case ACTION_SET_USER_OPT_IN:
            return {
                ...state,
                optIns: state.optIns.map((optIn) => {
                    if (optIn.opt_in_type === action.optInType)
                        return {
                            ...optIn,
                            opted_in: action.optInValue,
                        };
                    return optIn;
                }),
            };
        default:
            return state;
    }
}
